import React from "react";
import { PEIImage, PEIButton } from "@/common";
import { useVisibility } from "@/common";
import { MainNavbar } from "./MainNavbar";
import { HeaderCtas } from "./Ctas";
import { Socials } from "./Socials";
import styles from "@/styles/Header.module.scss";
import { URL, generatePathsOfLogosForBrands } from "@/utils";
const { brand } = URL;

export const Header = () => {
  const [visibility, toggleVisibility] = useVisibility(false);

  const handleLogoClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.location.assign(URL.basePEIURL);
  };

  return (
    <header className={styles.header}>
      <PEIButton
        className={
          !visibility
            ? styles["mobile-nav-toggle"]
            : `${styles["mobile-nav-toggle"]} ${styles["mobile-nav-toggle-cross"]}`
        }
        aria-controls='primary-navigation'
        aria-expanded='false'
        onClick={toggleVisibility}
      >
        <div className={!visibility ? styles.bar1 : `${styles.bar1} ${styles.change1}`}></div>
        <div className={!visibility ? styles.bar2 : `${styles.bar2} ${styles.change2}`}></div>
        <div className={!visibility ? styles.bar3 : `${styles.bar3} ${styles.change3}`}></div>
      </PEIButton>

      <a
        href={URL.basePEIURL}
        className={styles["logo-container"]}
        data-testid='header-brand-logo-link'
        onClick={handleLogoClick}
      >
        <PEIImage
          className={styles["logo-icon"]}
          src={generatePathsOfLogosForBrands(brand.toLowerCase())}
          alt={`${brand.toUpperCase()} logo`}
          width={202}
          height={66}
        />
      </a>
      <div className={styles.navigation} data-visible={visibility}>
        <MainNavbar />
        <HeaderCtas />
        <Socials />
      </div>
    </header>
  );
};
